import { format, getYear, isValid, parseISO } from 'date-fns';

const human_readable_date = function (date_string: string): string {
    // Validate input
    if (!date_string) {
        throw new Error('Invalid date string: empty string provided');
    }

    const date = parseISO(date_string);

    // Check if the parsed date is valid
    if (!isValid(date)) {
        throw new Error(`Invalid date string: ${date_string}`);
    }

    const currentYear = getYear(new Date());
    if (getYear(date) !== currentYear) {
        // not this year - show this year
        return format(date, 'MMM d, yyyy');
    } else {
        return format(date, 'MMM d');
    }
};

export default human_readable_date;
